/**
 * The two halves of a saved profile a body is actually stepped from.
 *
 * A `SaveProfile` is a name, a stat block, a progress record and a backpack. Two of those four are
 * a `CharacterSheet`, and pulling them out is a one-line habit that had started appearing in two
 * places: the shell, which announces the character to a lobby, and the mode, which builds a body
 * from it. Two copies of the same one-liner is one copy away from the two disagreeing about what a
 * character is, which is a desync rather than a typo.
 */

import type { CharacterSheet } from '@/sim/progression/characterSheet';
import type { SaveProfile } from '@/save/saveContract';

export function profileSheet(profile: SaveProfile): CharacterSheet {
  return { stats: profile.stats, progress: profile.progress };
}
